<template>
  <!--
    WHAT — Worklist detail tab "Data Source". Edits the DataAttribute join graph
      that defines the worklist's row grain (one row per listed patient / HCC /
      discharge). Wraps JoinGraphSection (→ StudioJoinBuilder), passing the
      worklist's /studio-sql/ preview endpoint so the combined SQL can render.

    CONTRACT — reads record.studio_config (defaults to
      { steps: [], primary_key_columns: ['BENE_MBI_ID'] }). On change emits
      patch({ studio_config: { steps, primary_key_columns } }), always coercing
      primary_key_columns to ['BENE_MBI_ID'] when empty. Re-emits refresh() when
      a DataAttribute is saved from the builder, so the shell reloads.

    NOTES — no local hydration state; studio_config is a computed pass-through,
      so no hydrating guard is needed here. selfChrome: true — JoinGraphSection
      draws its own card, so ArtifactDetail renders this body bare.
  -->
  <!-- Worklist "Data Source" — join graph whose grain is one row per listed
       patient. Patches studio_config. -->
  <JoinGraphSection
    :value="studioConfig"
    :attributes="context.attributes || []"
    :sql-url="`/api/impact_analytics/patient-worklists/${record.id}/studio-sql/`"
    @update:value="onStudio"
    @attribute-saved="$emit('refresh')"
  />
</template>

<script>
import JoinGraphSection from './JoinGraphSection.vue';

export default {
  name: 'WorklistDataSourceSection',
  components: { JoinGraphSection },
  props: {
    record: { type: Object, required: true },
    artifact: { type: Object, required: true },
    context: { type: Object, default: () => ({}) },
  },
  emits: ['patch', 'refresh'],
  computed: {
    studioConfig() { return this.record.studio_config || { steps: [], primary_key_columns: ['BENE_MBI_ID'] }; },
  },
  methods: {
    onStudio(sc) {
      this.$emit('patch', { studio_config: {
        steps: sc.steps,
        primary_key_columns: sc.primary_key_columns || ['BENE_MBI_ID'],
      } });
    },
  },
};
</script>
